import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';

import { MessageService } from '@services';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PortadoresServiceV2 } from '@servicesv2';
import { ComboboxPadrao } from 'models/combobox-padrao/combobox-padrao';
import { PortadoresViewModel } from '@financeiro';
import { ComboboxPadraoComponent } from '../combobox-padrao/combobox-padrao.component';

@Component({
  selector: 'app-combobox-portadores',
  templateUrl: './combobox-portadores.component.html',
  styleUrls: ['./combobox-portadores.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComboboxPortadoresComponent),
      multi: true
    }
  ]
})
export class ComboboxPortadoresComponent extends ComboboxPadrao<PortadoresViewModel> implements ControlValueAccessor, OnInit {
  override bindLabel = 'descricao';
  @Input() override label = 'Forma de Pagamento (Portador)';
  @Input() override required = false;
  @Input() override requiredText = 'A forma de pagamento (portador) é obrigatória';

  @Input() loading = false;
  @Input() disabled = false;
  @Input() notFoundPlusIcon = true;
  @Input() pencilIcon = true;
  @Input() autofocus = false;
  @Input() startOpen = false;
  @Input() atalho = null;
  @Output() changed = new EventEmitter();
  @Output() override onItemsChange = new EventEmitter();
  @ViewChild('comboboxPortadores', { static: false }) comboboxPortadores: ComboboxPadraoComponent<PortadoresViewModel>;

  constructor(
    service: PortadoresServiceV2,
    message: MessageService,
  ) {
    super('combobox_portadores', message, service);
  }

  ngOnInit() {
    if (this.autofocus) {
      this.focus();
    }
    if (this.startOpen) {
      this.openSearch();
    }
  }

  writeValue(value: number): void {
    this.selected.setValue(value);
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  handleOnChanged(value: number) {
    this.selected.setValue(value);
    this.changed.emit(value);
    this.onChange(value);
  }

  handleOnAdded(value: number) {
    this.selected.setValue(value);
    this.changed.emit(value);
    this.onChange(value);
  }

  handleOnEdited(value: number) {
    this.selected.setValue(value);
    this.changed.emit(value);
    this.onChange(value);
  }

  focus() {
    setTimeout(() => {
      this.comboboxPortadores.focus();
    }, 100);
  }

  openSearch() {
    setTimeout(() => {
      this.comboboxPortadores.openSearch();
    }, 100);
  }

  closeSearch() {
    setTimeout(() => {
      this.comboboxPortadores.closeSearch();
    }, 100);
  }
}
